// __webpack_public_path__ = '/local/templates/sova/';
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
window.axios.defaults.transformRequest = function (data, headers) {
    try {
        if (data instanceof FormData === false && data) {
            let formData = new FormData();

            Object.entries(data).forEach(([key, value]) => {
                if (typeof value === 'object') {
                    // create multidimensional array
                    for(let i in value) {
                        formData.append(`${key}[${i}]`, value[i] || null);
                    }
                } else if (value instanceof File) {
                    // add file type
                    formData.append(key, value, value.name);
                } else {
                    formData.append(key, value || null);
                }
            })
            return formData;
        }
        return data;
    } catch (err) {
        console.error(err);
    }
};

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */



window.$ = window.jQuery = require('jquery');
window.App = require('./libs/App').default;

// import VModal from 'vue-js-modal'
// window.Vue.use(VModal);
//
// import VueTheMask from 'vue-the-mask'
// Vue.use(VueTheMask)
//
//
window.Inputmask = require('inputmask').default;    // маски
require('magnific-popup');                          // подключаем popup (легче fancybox na 47 kb);
//
// import { VLazyImagePlugin } from "v-lazy-image";    // vue lazy load image
// Vue.use(VLazyImagePlugin);
//
window.dataLayer = window.dataLayer || [];
//
// /**
//  * используем глобальные примеси для всей vue
//  * */
// window.Vue.mixin(require('./mixins/screenWidth/screenWidth').default);
